import { PUBLIC_ORIGIN } from "../CanonicalUrl";

export const HOUSING_DEVELOPMENT_PROGRAMME = "housing-development";
export const HOUSING_DEVELOPMENT_EVENT_SERIES = "housing-development";
export const UUN_PRIVACY_NOTICE_PATH = "/privacy";
export const UUN_PRIVACY_CONTACT_EMAIL = "info@urbanunitynetwork.com";
export const NOVEMBER_CAREERS_SURVEY_CLOSE_DATE = "2026-11-30";
export const NOVEMBER_CAREERS_RESPONSE_RETENTION_END_DATE = "2027-11-30";
export const NOVEMBER_CAREERS_RESPONSE_EXPIRES_AT =
  "2027-12-01T00:00:00.000Z";

export const NOVEMBER_HOUSING_EVENT_ID =
  "housing-careers-kier-riverside-2026-11-25";
export const NOVEMBER_HOUSING_EVENT_SLUG =
  "kier-riverside-careers-event-november-2026";
export const NOVEMBER_HOUSING_EVENT_PATH =
  `/events/${NOVEMBER_HOUSING_EVENT_SLUG}--${NOVEMBER_HOUSING_EVENT_ID}`;

export const NOVEMBER_CAREERS_SURVEY_ID =
  "kier-riverside-careers-event-2026";
export const NOVEMBER_CAREERS_SURVEY_SLUG =
  "kier-riverside-careers-event-2026";
export const NOVEMBER_CAREERS_SURVEY_PATH =
  `/housing-development/surveys/${NOVEMBER_CAREERS_SURVEY_SLUG}`;

export const HOUSING_DEVELOPMENT_SOURCE_VALUES = Object.freeze([
  "event-qr",
  "poster-qr",
  "website",
  "email",
  "whatsapp",
  "housing-association",
  "riverside",
  "kier",
  "direct",
  "unknown",
]);

export const SURVEY_QUESTION_TYPES = Object.freeze([
  { value: "shortText", label: "Short text" },
  { value: "longText", label: "Long text" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "yesNo", label: "Yes / No" },
  { value: "singleChoice", label: "Single choice" },
  { value: "multipleChoice", label: "Multiple choice" },
  { value: "dropdown", label: "Dropdown" },
  { value: "ratingScale", label: "Rating scale" },
  { value: "rating1To5", label: "1–5 rating" },
  { value: "rating1To10", label: "1–10 rating" },
  { value: "date", label: "Date" },
  { value: "demographic", label: "Demographic question" },
]);

function surveySlug(value) {
  const record = value && typeof value === "object" ? value : {};
  const raw = value && typeof value === "object"
    ? record.slug || record.surveySlug || record.id || record.surveyId || ""
    : value;
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function surveySource(value) {
  const source = String(value || "").trim().toLowerCase();
  if (!source) return "";
  return HOUSING_DEVELOPMENT_SOURCE_VALUES.includes(source)
    ? source
    : "unknown";
}

export function buildHousingSurveyPath(slugOrSurvey, source = "") {
  const slug = surveySlug(slugOrSurvey);
  const path = slug
    ? `/housing-development/surveys/${slug}`
    : "/housing-development";
  const trackedSource = surveySource(source);
  return trackedSource
    ? `${path}?source=${encodeURIComponent(trackedSource)}`
    : path;
}

export function buildHousingSurveyAbsoluteUrl(slugOrSurvey, source = "") {
  return `${PUBLIC_ORIGIN}${buildHousingSurveyPath(slugOrSurvey, source)}`;
}

export const NOVEMBER_HOUSING_DEVELOPMENT_EVENT = Object.freeze({
  id: NOVEMBER_HOUSING_EVENT_ID,
  slug: NOVEMBER_HOUSING_EVENT_SLUG,
  publicPath: NOVEMBER_HOUSING_EVENT_PATH,
  title: "Kier & Riverside Careers Event",
  subtitle: "In collaboration with Urban Unity Network",
  description:
    "A careers event from Kier and Riverside in collaboration with Urban Unity Network.",
  programme: HOUSING_DEVELOPMENT_PROGRAMME,
  eventCategory: HOUSING_DEVELOPMENT_PROGRAMME,
  eventSeries: HOUSING_DEVELOPMENT_EVENT_SERIES,
  eventType: HOUSING_DEVELOPMENT_PROGRAMME,
  status: "approved",
  lifecycleStatus: "upcoming",
  startDate: "2026-11-25",
  date: "2026-11-25",
  startTime: "09:00",
  endTime: "14:00",
  venueName: "Phoenix Heights Community Centre",
  location: "Phoenix Heights Community Centre",
  addressLine1: "140a Byng Street",
  area: "Isle of Dogs",
  city: "London",
  postcode: "E14 9AR",
  address: "140a Byng Street, Isle of Dogs, London, E14 9AR",
  partnerOrganisations: ["Kier", "Riverside", "Urban Unity Network"],
  organisations: ["Kier", "Riverside", "Urban Unity Network"],
  registrationEnabled: false,
  registrationOpen: false,
  surveyIds: [NOVEMBER_CAREERS_SURVEY_ID],
  surveySlugs: [NOVEMBER_CAREERS_SURVEY_SLUG],
  surveyId: NOVEMBER_CAREERS_SURVEY_ID,
  surveySlug: NOVEMBER_CAREERS_SURVEY_SLUG,
  surveyPath: NOVEMBER_CAREERS_SURVEY_PATH,
  flyerUrl: "",
  flyerStoragePath: "",
});

export const NOVEMBER_CAREERS_SURVEY = Object.freeze({
  id: NOVEMBER_CAREERS_SURVEY_ID,
  surveyId: NOVEMBER_CAREERS_SURVEY_ID,
  slug: NOVEMBER_CAREERS_SURVEY_SLUG,
  surveySlug: NOVEMBER_CAREERS_SURVEY_SLUG,
  publicPath: NOVEMBER_CAREERS_SURVEY_PATH,
  title: "Riverside x Kier Careers Fair",
  surveyName: "Riverside x Kier Careers Fair",
  introduction:
    "Phoenix Heights Community Centre, 140a Byng Street, London E14 9AR",
  description:
    "Tell Riverside, Kier and Urban Unity Network about your interest in the Community Careers Fair.",
  eventId: NOVEMBER_HOUSING_EVENT_ID,
  programme: HOUSING_DEVELOPMENT_PROGRAMME,
  partnerOrganisations: ["Kier", "Riverside", "Urban Unity Network"],
  status: "published",
  active: true,
  published: true,
  closeDate: NOVEMBER_CAREERS_SURVEY_CLOSE_DATE,
  privacyNoticePath: UUN_PRIVACY_NOTICE_PATH,
  privacyContactEmail: UUN_PRIVACY_CONTACT_EMAIL,
  responseRetentionEndDate: NOVEMBER_CAREERS_RESPONSE_RETENTION_END_DATE,
  responseRetentionAction: "delete-or-anonymise",
  responseExpiresAt: NOVEMBER_CAREERS_RESPONSE_EXPIRES_AT,
  questions: [
    {
      id: "name",
      label: "Name",
      type: "shortText",
      required: true,
      maxLength: 160,
      personalData: true,
      autoComplete: "name",
    },
    {
      id: "phone-number",
      label: "Phone number",
      type: "phone",
      required: false,
      maxLength: 40,
      personalData: true,
      autoComplete: "tel",
    },
    {
      id: "email-address",
      label: "Email address",
      type: "email",
      required: true,
      maxLength: 254,
      personalData: true,
      autoComplete: "email",
    },
    {
      id: "lives-locally",
      label:
        "Do you currently live locally in the area around the community centre?",
      type: "singleChoice",
      required: true,
      options: ["Yes", "No"],
    },
    {
      id: "housing-association-resident",
      label: "Are you a resident of a housing association property?",
      type: "shortText",
      required: true,
      helper: "If you are not or unaware please put 'N/A'",
      helpText: "If you are not or unaware please put 'N/A'",
      maxLength: 160,
      personalData: true,
    },
    {
      id: "home-address-postcode",
      label: "What is your home address and postcode?",
      type: "shortText",
      required: false,
      maxLength: 300,
      personalData: true,
      autoComplete: "street-address",
    },
    {
      id: "attend-community-careers-fair",
      label: "Would you like to attend our Community Careers Fair?",
      type: "singleChoice",
      required: true,
      options: ["Yes", "No", "Maybe"],
    },
    {
      id: "careers-fair-goal",
      label: "What are you hoping to get from attending the Careers Fair?",
      type: "singleChoice",
      required: true,
      options: [
        "Find a job",
        "Explore different career opportunities",
        "Meet local employers",
        "Find out about apprenticeships",
        "Get help with my CV",
        "Improve my interview skills",
        "Find work experience",
        "I'm not sure yet",
        "All of the above",
        "Other",
      ],
    },
    {
      id: "cv-workshop-interest",
      label: "Would you be interested in taking part in a CV workshop on the day?",
      type: "singleChoice",
      required: true,
      options: ["Yes", "No", "Maybe"],
    },
    {
      id: "interview-practice-interest",
      label: "Would you be interested in taking part in interview practice on the day?",
      type: "singleChoice",
      required: true,
      options: ["Yes", "No", "Maybe"],
    },
  ],
});

